import { useState } from "react";
import { tx } from "../i18n";
import { Button } from "./Button";
import { Alert } from "./Card";
import { Field, Input } from "./Field";
import "./RepoCreate.css";

/* ══ git 저장소 › 「새 리포 만들기」 — 결정 docs/decisions/repository.md 「리포 생성의 주인」 ══
   호스트(Gitea)에 리포를 만들고 **같은 요청에서** 이 설치에 건다(`POST /admin/repos/create`).
   이름 모양은 서버가 다시 본다 — 여기서는 빈 값만 막는다(규칙을 두 벌로 두지 않는다). */

export type NewRepoInput = { owner: string; name: string; private: boolean };

/** 접힌 채로 서는 단추 + 펼친 폼. 실패 문장은 서버가 준 것을 그대로 받는다(`error`). */
export function RepoCreateForm({
  busy,
  error,
  open: openInit = false,
  onSubmit,
}: {
  busy?: boolean;
  error?: string | null;
  open?: boolean;
  onSubmit?: (v: NewRepoInput) => void;
}) {
  const [open, setOpen] = useState(openInit);
  const [owner, setOwner] = useState("");
  const [name, setName] = useState("");
  const [priv, setPriv] = useState(true);
  if (!open)
    return (
      <div className="rcreate__closed">
        <Button size="sm" onClick={() => setOpen(true)}>
          {tx("repoCreate.open")}
        </Button>
        <span className="caption">{tx("repoCreate.openHint")}</span>
      </div>
    );
  return (
    <form
      className="rcreate"
      onSubmit={(e) => {
        e.preventDefault();
        if (name.trim()) onSubmit?.({ owner: owner.trim(), name: name.trim(), private: priv });
      }}
    >
      <h4 className="rcreate__title">{tx("repoCreate.title")}</h4>
      {error ? <Alert tone="error">{error}</Alert> : null}
      <div className="rcreate__row">
        <Field label={tx("repoCreate.owner")} hint={tx("repoCreate.ownerHint")}>
          {(id) => <Input id={id} autoComplete="off" value={owner} onChange={(e) => setOwner(e.target.value)} placeholder="irolab" />}
        </Field>
        <Field label={tx("repoCreate.name")} hint={tx("repoCreate.nameHint")}>
          {(id) => <Input id={id} autoComplete="off" value={name} onChange={(e) => setName(e.target.value)} placeholder="new-service" required />}
        </Field>
      </div>
      <label className="b-check">
        <input type="checkbox" checked={priv} onChange={(e) => setPriv(e.target.checked)} />
        {tx("repoCreate.private")}
      </label>
      <div className="rcreate__acts">
        <span className="rcreate__gap" />
        <Button type="button" onClick={() => setOpen(false)} disabled={busy}>
          {tx("common.action.cancel")}
        </Button>
        <Button type="submit" variant="primary" loading={busy} disabled={!name.trim()}>
          {tx("repoCreate.submit")}
        </Button>
      </div>
    </form>
  );
}
